import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDispositivosState } from 'selectors/dispositivos.selector';
import {
  Form,
  Row,
  Col,
  Select,
  Input,
  Space,
  DatePicker,
  ConfigProvider,
  Divider,
  message
} from 'antd';
import { DispositivosContext } from 'contexts/DispositivosContext';
import { Button, Tooltip, Table, ExcelButton, HeaderPage } from 'components';
import EliminAsig from 'assets/images/Dispositivos/acciones_elimin_asig.svg';
import EliminDispo from 'assets/images/Dispositivos/acciones_elimin_dispo.svg';
import { downloadExcelDispos } from 'actions/files.actions';
import {
  getDevicesUnassigned,
  getDevicesAssigned,
  saveAssignDevice
} from 'actions/devices.actions';
import { getUsersNoDisposAsig } from 'actions/users.actions';
import { base64toBlob } from 'utils/file';
import moment from 'moment';
import esES from 'antd/locale/es_ES';
import Cookie from 'universal-cookie';
import { FormOutlined } from '@ant-design/icons';
import * as MensGrales from 'constants/MensajesGenerales';
import ModalDispo from './ModalDispo';
import './AsignarDispositivo.scss';
import 'containers/CuentasUsuarios/CuentasUsuarios/TableUser.scss';

function AsignarDispositivo() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [locale] = useState(esES);
  const dateFormat = 'DD MMMM YYYY';
  const placement = 'topRight';
  const { counter, setCounter } = useContext(DispositivosContext);
  const [valueMostrar, setValueMostrar] = useState(10);
  const [disposAsignados, setDisposAsignados] = useState([]);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [encuestadores, setEncuestadores] = useState([]);
  const [listImei, setListImei] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [disposAsignadosFiltro, setDisposAsignadosFiltro] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [asigToEdit, setAsigToEdit] = useState(null);
  const [tipoModal, setTipoModal] = useState(null);
  let tokken = null;
  const coki = new Cookie();

  const { loading } = useSelector(selectDispositivosState);

  async function getDevices() {
    setListImei([]);
    const { success, response } = await dispatch(getDevicesUnassigned());
    if (success && response?.data.code === 200) {
      for (let i = 0; i < response.data.dispositivos.length; i += 1) {
        const numImei = {
          idDispositivo: response.data.dispositivos[i].idDispositivo,
          imei: response.data.dispositivos[i].imei
        };
        if (!listImei.some((item) => item.idDispositivo === numImei.idDispositivo)) {
          listImei.push(numImei);
        }
      }
      setListImei(listImei);
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    } else {
      messageApi.error(MensGrales.MAV1_2);
    }
  }

  async function getEncuestadores() {
    const { success, response } = await dispatch(getUsersNoDisposAsig());
    if (success && response?.data.code === 200) {
      setEncuestadores(response.data.usuarios);
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    }
  }

  async function getAssignedDevices() {
    const { success, response } = await dispatch(getDevicesAssigned());
    if (success && response?.data.code === 200) {
      setDisposAsignados(response.data.dispositivosAsignados);
      setDownloadingExcel(!(response.data.dispositivosAsignados.length > 0));
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    }
  }

  const onFinish = async (values) => {
    tokken = coki.get('JWT-TOKEN-SIMAC');
    const data = {
      asignacion: {
        idDispositivo: values.idDispositivo,
        idUsuario: values.idUsuario
      },
      token: tokken
    };
    const { success, response } = await dispatch(saveAssignDevice(data));
    if (success && response?.data.code === 200) {
      message.success('Guardado exitoso');
      setCounter(counter + 1);
    } else {
      message.error(response.causa);
    }
  };

  useEffect(() => {
    form.resetFields();
    setListImei([]);
    setDisposAsignados([]);
    getDevices();
    getEncuestadores();
    getAssignedDevices();
  }, [counter]);

  const handleDownloadExcel = async () => {
    setDownloadingExcel(true);
    const { success, response } = await dispatch(downloadExcelDispos(disposAsignados));
    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
          setDownloadingExcel(false);
        }
      }
    }
    setDownloadingExcel(false);
  };

  const FilterByIMEI = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>IMEI</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={disposAsignados?.length === 0}
            allowClear
            onChange={(e) => {
              setSearchValue('');
              const currValue = e.target.value;
              const copiaDis = [...disposAsignados];
              if (currValue.length > 0 && copiaDis.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaDis.filter((entry) =>
                  entry.imei.toString().includes(currValue)
                );
                setDisposAsignadosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );

  const FilterByNumero = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>Número</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={disposAsignados?.length === 0}
            allowClear
            onChange={(e) => {
              setSearchValue('');
              const currValue = e.target.value;
              const copiaDis = [...disposAsignados];
              if (currValue.length > 0 && copiaDis.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaDis.filter((entry) =>
                  entry.numero.toString().includes(currValue)
                );
                setDisposAsignadosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );

  const FilterByAsignado = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>Asignado a</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={disposAsignados?.length === 0}
            allowClear
            onChange={(e) => {
              setSearchValue('');
              const currValue = e.target.value;
              const copiaDis = [...disposAsignados];
              if (currValue.length > 0 && copiaDis.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaDis.filter(
                  (entry) =>
                    entry.nombre?.includes(currValue) ||
                    entry.nombre?.toLowerCase().includes(currValue) ||
                    entry.nombre?.toUpperCase().includes(currValue)
                );
                setDisposAsignadosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );

  const FilterByFecha = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>Fecha de asignación</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Space direction="vertical">
            <DatePicker
              disabled={disposAsignados?.length === 0}
              locale={locale}
              onChange={(_e, dateString) => {
                console.log('second parameter de date picker: ', dateString);
                setSearchValue('');
                const currValue = dateString;
                const copiaDis = [...disposAsignados];
                if (currValue.length > 0 && copiaDis.length > 0) {
                  setSearchValue(currValue);
                  const filteredData = copiaDis.filter((entry) =>
                    // moment(entry.fechaHora).format('DD MMMM yyyy').includes(currValue)
                    console.log(
                      'moment(entry.fechaHora): ',
                      moment(entry.fechaHora).format('DD MMMM yyyy')
                    )
                  );
                  setDisposAsignadosFiltro(filteredData);
                }
              }}
              placement={placement}
              placeholder=""
              format={dateFormat}
            />
          </Space>
        </Col>
      </Row>
    </>
  );

  const columns = [
    {
      title: FilterByIMEI,
      dataIndex: 'imei',
      width: '5%',
      className: 'my-column-tbl'
    },
    {
      title: FilterByNumero,
      dataIndex: 'numero',
      width: '4%',
      className: 'my-column-tbl'
    },
    {
      title: 'Activo',
      dataIndex: 'estatus',
      width: '1%',
      className: 'my-column-tbl',
      filters: [
        {
          text: 'Sí',
          value: 1
        },
        {
          text: 'No',
          value: 0
        }
      ],
      render: (record) => (
        <div>
          <span>{record === 1 ? <p>Sí</p> : <p>No</p>}</span>
        </div>
      )
    },
    {
      title: FilterByAsignado,
      dataIndex: 'nombre',
      width: '4%',
      className: 'my-column-tbl'
    },
    {
      title: FilterByFecha,
      dataIndex: 'fechaHora',
      width: '4%',
      className: 'my-column-tbl',
      render: (record) => <span>{`${moment(record).format('DD MMMM yyyy hh:mm a')}`}</span>
    },
    {
      title: 'Quién asignó',
      dataIndex: 'usuario',
      width: '3%',
      className: 'my-column-tbl',
      filters: [
        {
          text: 'carlos.lopezl',
          value: 'carlos.lopezl'
        }
      ]
    },
    {
      title: 'Acciones',
      width: '3%',
      className: 'my-column-tbl',
      align: 'center',
      render: (_text, record) => (
        <div className="column-acciones">
          <Tooltip title="Editar" class="tooltip-acciones" placement="topLeft">
            <Button
              shape="circle"
              className="btn-col-acciones"
              icon={<FormOutlined className="icons-tbl-users" />}
              onClick={() => {
                setIsModalOpen(true);
                setTitle('Editar asignación');
                setAsigToEdit(record);
                setTipoModal(1);
              }}
            />
          </Tooltip>
          <Tooltip title="Eliminar dispositivo" class="tooltip-acciones" placement="topLeft">
            <Button
              className="btn-col-acciones"
              /* icon={<EliminDispo className="icon-column-acciones" />} */
              icon={
                <img
                  src={EliminDispo}
                  className="icon-column-acciones"
                  alt=""
                  style={{ width: 16, height: 16 }}
                />
              }
              onClick={() => {
                setIsModalOpen(true);
                setTitle('');
                setAsigToEdit(record);
                setTipoModal(2);
              }}
            />
          </Tooltip>
          <Tooltip title="Eliminar asignación" class="tooltip-acciones" placement="topLeft">
            <Button
              className="btn-col-acciones"
              /* icon={<EliminAsig className="icon-column-acciones" />} */
              icon={
                <img
                  src={EliminAsig}
                  className="icon-column-acciones"
                  alt=""
                  style={{ width: 16, height: 16 }}
                />
              }
              onClick={() => {
                setIsModalOpen(true);
                setTitle('');
                setAsigToEdit(record);
                setTipoModal(3);
              }}
            />
          </Tooltip>
        </div>
      )
    }
  ];

  return (
    <div className="asignar-container">
      <HeaderPage
        section=""
        section2="Asignar dispositivo"
        title="Asignar dispositivo"
        header="Selecciona el número IMEI y nombre del monitor para asignar el dispositivo."
      />
      <Form id="formAssign" layout="vertical" form={form} onFinish={onFinish}>
        <div className="inputs-asignarDispo">
          <Form.Item
            name="idDispositivo"
            label="IMEI:"
            rules={[{ required: true, message: 'Dato requerido.' }]}>
            <Select
              style={{ width: '350px' }}
              placeholder="Número IMEI"
              allowClear
              options={(listImei || []).map((d) => ({
                value: d.idDispositivo,
                label: `${d.imei}`
              }))}
              optionFilterProp="label"
              filterOption={(input, option) => {
                return option.label.includes(input);
              }}
              showSearch
            />
          </Form.Item>
          <Form.Item
            name="idUsuario"
            label="Monitor:"
            rules={[{ required: true, message: 'Dato requerido.' }]}>
            <Select
              style={{ width: '350px' }}
              placeholder="Nombre del monitorista"
              allowClear
              options={(encuestadores || []).map((e) => ({
                value: e.idUsuario,
                label: `${e.nombre} ${e.apellidoPaterno ? e.apellidoPaterno : ''} ${
                  e.apellidoMaterno ? e.apellidoMaterno : ''
                }`
              }))}
              optionFilterProp="label"
              filterOption={(input, option) => {
                return option.label.toLowerCase().includes(input.toLowerCase());
              }}
              showSearch
            />
          </Form.Item>
        </div>
        <div className="button-asignarDispo">
          <Button type="primary" htmlType="submit" text="Asignar" />
        </div>
      </Form>
      {contextHolder}
      <div id="tabla">
        <h1 className="title-h1">Dispositivos asignados</h1>
        <div className="div-header-table" style={{ marginTop: '22px' }}>
          <Row style={{ width: '100%' }}>
            <Col span={12} className="col-header-table-col1">
              <span style={{ marginRight: '1%' }}>Mostrar </span>
              <Select
                placeholder={valueMostrar}
                options={[
                  {
                    value: 10,
                    label: '10'
                  },
                  {
                    value: 20,
                    label: '20'
                  },
                  {
                    value: 50,
                    label: '50'
                  }
                ]}
                onChange={setValueMostrar}
                style={{
                  width: '58px',
                  marginRight: '9px',
                  borderColor: 'black'
                }}
              />
              <span style={{ marginRight: '1.5%' }}>registros</span>
              <ExcelButton type="text" disabled={downloadingExcel} onClick={handleDownloadExcel} />
            </Col>
          </Row>
        </div>
        <div style={{ width: '100%' }}>
          <ConfigProvider locale={locale}>
            <Table
              // rowKey={(record) => record}
              bordered={false}
              columns={columns}
              dataSource={searchValue === '' ? disposAsignados : disposAsignadosFiltro}
              pagination={{
                position: ['bottomRight'],
                size: 'small'
                // total:
              }}
              loading={loading}
            />
            <Divider style={{ marginTop: 0, marginBottom: 0 }} />
          </ConfigProvider>
        </div>
        {isModalOpen ? (
          <ModalDispo
            title={title}
            open={isModalOpen}
            callback={() => setIsModalOpen(false)}
            asigToEdit={asigToEdit}
            tipoModal={tipoModal}
            encuestadores={encuestadores}
          />
        ) : null}
      </div>
    </div>
  );
}

export default AsignarDispositivo;
